import React, {useState} from 'react';
import {Card, Flex} from "antd";
import style from "./ProfileListCard.module.scss";
import {StyledCard} from "./ProfileListCard.styled";
import {LeftOutlined, PoweroffOutlined} from "@ant-design/icons";
import { FaChevronLeft } from "react-icons/fa6";
import {useNavigate} from "react-router-dom";
import {ProfileListCardProps} from "../../models";
import LogOutModal from "./LogOutModal";

const ProfileListCard = ({item,clickedOnLogOut} :ProfileListCardProps) => {
    const navigate =useNavigate()

    return (
        <StyledCard onClick={() => {
            if (item.title === "خروج از حساب کاربری" )
                clickedOnLogOut();
            else
            navigate(item?.path)
        }

        }  >
            <Flex justify={"space-between"} align={"center"}>
                <span> {item?.title} </span>
                {item.title === "خروج از حساب کاربری" ? <span><PoweroffOutlined className={style.logOutIcon}/></span> :
                    <span> <FaChevronLeft className={style.icons}/> </span>}


            </Flex>
        </StyledCard>
    )

};

export default ProfileListCard;